/* eslint-disable jsx-a11y/alt-text */
import { Image } from 'react-datocms/image';
import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import { Badge, Person } from '@carbonify/ui';
import { UsersIcon } from '@heroicons/react/24/outline';
import CtaButton from 'components/CtaButton';
import InlineRichText from 'components/RichContent/InlineRichText';
import { ResponsiveImage } from 'services/graphql';

import styles from './InfluencerBlock.module.css';

interface InfluencerBlockRecord extends CdaStructuredTextRecord {
  quote: string;
  cta: string;
  image: ResponsiveImage;
  person: {
    image?: ResponsiveImage;
    title: string;
    subtitle?: string;
  };
}

export default function InfluencerBlock({ quote, cta, image, person }: InfluencerBlockRecord) {
  return (
    <div className={styles.influencer}>
      <div className={styles.content}>
        <InlineRichText as="blockquote">{quote}</InlineRichText>
        <Person
          className={styles.person}
          title={person.title}
          subtitle={person.subtitle}
          image={
            person.image && (
              <Image
                data={person.image.responsiveImage}
                objectFit="cover"
                objectPosition="center"
              />
            )
          }
        />
        <div className={styles.spacer} />
        <Badge
          compact
          variant="secondaryLight"
        >
          <UsersIcon className={styles.badgeIcon} /> schon 200+ mitglieder
        </Badge>
        <CtaButton
          className={styles.cta}
          value={cta}
        />
      </div>
      {image && (
        <Image
          data={image.responsiveImage}
          className={styles.image}
          objectFit="cover"
          objectPosition="center"
        />
      )}
    </div>
  );
}
